import { useEffect, useState } from 'react';
import { 
  Trophy, 
  CaretLeft, 
  Sparkle, 
  CheckCircle,
  Star,
  Confetti,
} from '@phosphor-icons/react';
import ModalCloseButton from "../ui/ModalCloseButton";
import './OnboardingTour.css';

function OnboardingCompleteModal({ isOpen, onClose, therapistName }) {
  const [isAnimating, setIsAnimating] = useState(false);
  
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => setIsAnimating(true), 100);
      return () => clearTimeout(timer);
    }
    setIsAnimating(false);
  }, [isOpen]);
  
  if (!isOpen) return null;
  
  const firstName = therapistName || 'מטפל/ת';
  
  return (
    <div className="onboarding-modal-overlay">
      <div className={`onboarding-modal onboarding-complete-modal ${isAnimating ? 'animate-in' : ''}`}>
        <ModalCloseButton onClick={onClose} />
        
        {/* Trophy animation */}
        <div className="onboarding-complete-icon">
          <Trophy size={72} weight="duotone" className="trophy-icon" />
          <div className="celebration-particles">
            <Confetti size={20} weight="fill" className="celebration-particle c1" />
            <Star size={18} weight="fill" className="celebration-particle c2" />
            <Sparkle size={20} weight="fill" className="celebration-particle c3" />
            <Star size={16} weight="fill" className="celebration-particle c4" />
            <Sparkle size={18} weight="fill" className="celebration-particle c5" />
            <Confetti size={16} weight="fill" className="celebration-particle c6" />
          </div>
        </div>
        
        {/* Content */}
        <div className="onboarding-complete-content">
          <h2>כל הכבוד, {firstName}!</h2>
          <h3>סיימת את ההדרכה!</h3>
          
          <p className="onboarding-complete-text">
            עכשיו יש לך את כל הכלים להתחיל לעבוד עם המערכת.
            <br />
            אנחנו בטוחים שתעופו על זה!
          </p>
          
          <div className="onboarding-complete-checklist">
            <h4>עכשיו אתה יודע:</h4>
            <ul>
              <li>
                <CheckCircle size={18} weight="fill" className="check-icon-svg" />
                ליצור ולנהל מטופלים כמו מקצוען
              </li>
              <li>
                <CheckCircle size={18} weight="fill" className="check-icon-svg" />
                לקבוע פגישות ולנהל את היומן
              </li>
              <li>
                <CheckCircle size={18} weight="fill" className="check-icon-svg" />
                לטפל בפגישות ממתינות (אף אחת לא נשכחת!)
              </li>
              <li>
                <CheckCircle size={18} weight="fill" className="check-icon-svg" />
                לנהל תשלומים ולהפיק חשבוניות
              </li>
              <li>
                <CheckCircle size={18} weight="fill" className="check-icon-svg" />
                להשתמש בארגז הכלים המלא
              </li>
            </ul>
          </div>
          
          <div className="onboarding-complete-tip">
            <Sparkle size={20} weight="fill" className="tip-icon" />
            <p>
              <strong>טיפ:</strong> התחל ביצירת המטופל הראשון שלך!
              <br />
              לחץ על כפתור ה-<strong>+</strong> בפינה או על "מטופל חדש".
            </p>
          </div>
        </div>
        
        {/* Actions */}
        <div className="onboarding-complete-actions">
          <button className="onboarding-complete-btn onboarding-complete-btn-primary" onClick={onClose}>
            <CaretLeft size={20} weight="bold" />
            יאללה, בואו נתחיל לעבוד!
          </button>
          
          <p className="onboarding-restart-hint">
            תמיד אפשר להפעיל את ההדרכה שוב דרך תפריט הפרופיל שלך (לחיצה על התמונה בפינה) ← "הפעל הדרכה"
          </p>
        </div>
      </div>
    </div>
  );
}

export default OnboardingCompleteModal;
